import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Dashboard|Ban Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateBanForm';
export type SPCandidateBanFormLocNames =
	| `${LocNameStart}LabelUntil`
	| `${LocNameStart}ErrorUntilRequired`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ErrorCommentsRequired`
	| `${LocNameStart}ButtonRemoveBan`
	| `${LocNameStart}ButtonBan`
	| `${LocNameStart}ButtonUpdateBan`
	| `${LocNameStart}ErrorNotification`
	| `${LocNameStart}RadioLabelActionRemoveBan`
	| `${LocNameStart}RadioLabelActionUpdateBan`
	| `${LocNameStart}LabelInvalidateAllData`
	| `${LocNameStart}TooltipInvalidateAllDataTooltip`;

export const spCandidateBanFormLocs: LocDefs<SPCandidateBanFormLocNames> = {
	SPCandidateBanFormLabelUntil: {
		defaultValue: 'Until',
		description: 'Label for: Until.',
		displayPath: `${pathStart}Ban Until`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.Until',
		...sharedProperties,
	},
	SPCandidateBanFormErrorUntilRequired: {
		defaultValue: 'A valid end date is required.',
		description: 'Error for: The end date is required.',
		displayPath: `${pathStart}Ban Until Date Required`,
		displayType: 'Error',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldError.DateRequired',
		...sharedProperties,
	},
	SPCandidateBanFormLabelComments: {
		defaultValue: 'Comments',
		description: 'Label for: Comments.',
		displayPath: `${pathStart}Comments`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.Comments',
		...sharedProperties,
	},
	SPCandidateBanFormRadioLabelActionRemoveBan: {
		defaultValue: 'Remove Ban',
		description: 'Label for Remove Ban radio button.',
		displayPath: `${pathStart}Radio Label Remove Ban`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateBanFormRadioLabelActionUpdateBan: {
		defaultValue: 'Update Ban',
		description: 'Label for Update Ban radio button.',
		displayPath: `${pathStart}Radio Label Update Ban`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateBanFormErrorCommentsRequired: {
		defaultValue: 'Comments are required.',
		description: 'Error for: Comments are required.',
		displayPath: `${pathStart}Comments Required`,
		displayType: 'Error',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldError.CommentsRequired',
		...sharedProperties,
	},
	SPCandidateBanFormButtonRemoveBan: {
		defaultValue: 'Remove Ban',
		description: 'Button for: Remove Ban.',
		displayPath: `${pathStart}Remove Ban`,
		displayType: 'Button',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.Button.StopBan',
		...sharedProperties,
	},
	SPCandidateBanFormButtonBan: {
		defaultValue: 'Ban',
		description: 'Button for: Ban.',
		displayPath: `${pathStart}Ban`,
		displayType: 'Button',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.Button.Ban',
		...sharedProperties,
	},
	SPCandidateBanFormButtonUpdateBan: {
		defaultValue: 'Update Ban',
		description: 'Button for: Update Ban.',
		displayPath: `${pathStart}Update Ban`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateBanFormErrorNotification: {
		defaultValue: 'Please check the form for errors.',
		description: 'Error notification shown when the form is invalid.',
		displayPath: `${pathStart}Error Notification`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPCandidateBanFormLabelInvalidateAllData: {
		defaultValue: 'Invalidate all data',
		description: 'Label for: Invalidate all data checkbox.',
		displayPath: `${pathStart}Invalidate All Data`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateBanFormTooltipInvalidateAllDataTooltip: {
		defaultValue: 'This action will mark all candidate data as invalid.',
		description: 'Tooltip shown when hovering over the invalidate all data checkbox.',
		displayPath: `${pathStart}Invalidate All Data Tooltip`,
		displayType: 'Content',
		...sharedProperties,
	},
};

export type SPCandidateBanFormLocType = LocMap<SPCandidateBanFormLocNames>;
